import { useContext, useEffect, useState } from 'react';
import { ROLE_NAVS } from 'shared/routes';
import { UserContext } from 'shared/contexts/UserContext';

/**
 * Determine which nav links should be available depending
 * on the role of the current user.
 */
const useNavLinks = ():Array<NavLink> => {
  const [userState] = useContext(UserContext);
  const { role } = userState;
  const [links, setLinks] = useState<Array<NavLink>>([]);

  useEffect(() => {
    if (role) {
      setLinks(ROLE_NAVS[role]);
    } else {
      setLinks([]);
    }
  }, [role]);

  return links;
};

export default useNavLinks;
